module.exports = __webpack_public_path__ + "img/transform-bg.ccb58da8.svg";